module.exports = __webpack_public_path__ + "static/media/6_of_clubs.5bc579cd.png";